import React from 'react';
import PropTypes from 'prop-types';
import TimeInput from '../input/TimeInput';
import EditableToggle from './EditableToggle';

const EditableTimeInput = ({
  onChange,
  value,
  submitOnBlur,
  inputClassName,
  readOnly,
  placeholder,
  displayValue,
  displayClassName,
  ...rest
}) => (
  <EditableToggle
    onSubmit={onChange}
    value={value}
    readOnly={readOnly}
    displayValue={displayValue}
    className={displayClassName}
  >
    {({ inputValue, setInputValue, submit, cancel, handleKeyDown }) => (
      <TimeInput
        value={inputValue === null ? '' : inputValue}
        onChange={setInputValue}
        onBlur={submitOnBlur ? submit : cancel}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        autoComplete="off"
        autofocus
        {...rest}
      />
    )}
  </EditableToggle>
);

EditableTimeInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  submitOnBlur: PropTypes.bool,
  placeholder: PropTypes.string,
  displayClassName: PropTypes.string,
  readOnly: PropTypes.bool,
  displayValue: PropTypes.node,
};
EditableTimeInput.defaultProps = {
  submitOnBlur: true,
  displayClassName: '',
  placeholder: '',
  readOnly: false,
  displayValue: null,
  value: null,
};

export default EditableTimeInput;
